module.exports = __webpack_public_path__ + "static/img/appdownload-bg.0f4ba3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/home/appdownload-bg.png
// module id = EICC
// module chunks = 0